import * as z from 'zod';

export const CartItemSchema = z.object({
    idDesignJson: z.number(),
    idProduct: z.number(),
    idProductAttribute: z.number(),
    designName: z.string(),
    productName: z.string(),
    attributeName: z.string(),
    idAttributeFabric: z.number(),
    fabricName: z.string(),
    idAttributeSize: z.number(),
    sizeName: z.string(),
    quantity: z.number(),
});

export type CartItem = z.infer<typeof CartItemSchema>;

export const CartItemsSchema = z.array(CartItemSchema);

export type CartItems = z.infer<typeof CartItemsSchema>;
